import React from 'react';
import { connect } from 'react-redux';
import { i18n } from 'fishx';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { Button, message } from '@whalecloud/fdx';
import { renderFormItems } from '@/utils';
import { getUnitFormItems, getBaseNameKey } from './utils';

import styles from './index.module.less';

const PlanFormItems = props => {
  const {
    index, // index，为了做区分用
    addressId,
    qrySalesRuleParams,
    exchangeId,
    stdCode,
    unitInfo,
    formItemData = {},
    modelKey,
    sameNumberInfo,
    form: { getFieldDecorator, getFieldValue },
    onNbrChange,
    onDelete,
    mainOfferCurrentDpp,
  } = props;
  const { unitId, unitName, servType = '', lowerLimit, comboUnitOfferDtoList = [] } = unitInfo;

  const getFormItemName = text => `${text}${getBaseNameKey(unitId, index, servType)}`;

  const getNmuberIndepId = () => get(formItemData, 'offerDetail.indepProdSpecId') || get(getFieldValue(getFormItemName('offerDetail')), 'indepProdSpecId');
  const formItemObj = {
    ...formItemData,
    modelKey,
    number: !isEmpty(sameNumberInfo) ? sameNumberInfo : formItemData.number,
    offerList: comboUnitOfferDtoList,
    mainOfferCurrentDpp,
    numberProps: {
      addressId,
      exchangeId,
      stdCode,
      subsServiceType: getNmuberIndepId(),
      onModalOpen: () => {
        if (!getNmuberIndepId()) {
          message.warning(i18n('OFFER_PLAN_SELECT_FIRST'));
          return false;
        }
        return true;
      },
    },
  };

  const formItemFun = {
    getFormItemName,
    handleNumberSelect: onNbrChange,
  };

  return (
    <div className={styles.unitGroup} key={`plan-${index}`}>
      <div className={styles.unitHeader}>
        <h4 className="blockSubTitle">{unitName}-{index + 1}</h4>
        {
          (index + 1) > lowerLimit && (
            <Button
              type="primary"
              ghost
              style={{ color: '#4477EE' }}
              onClick={onDelete}
            >
              {i18n('COMMON_DELETE')}
            </Button>
          )
        }
      </div>
      <div className="formItemBox">
        {renderFormItems(getUnitFormItems({ ...formItemObj, qrySalesRuleParams }, formItemFun), getFieldDecorator)}
      </div>
    </div>
  );
};

export default connect((state, { modelKey }) => ({
  sameNumberInfo: state[modelKey].sameNumberInfo,
}))(PlanFormItems);
